import { Flight } from './types';
import { CheckinSegmentFragment, SegmentFragment } from '@websky/graphql';

export const isCheckinFlightGuard = (flight: Flight): flight is CheckinSegmentFragment => {
	return !('segments' in flight);
};

export const isCheckinSegmentGuard = (
	segment: CheckinSegmentFragment | SegmentFragment
): segment is CheckinSegmentFragment => {
	return 'checkinInfo' in segment;
};
